module.exports = __webpack_public_path__ + "static/img/agro.81e8064.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-login/agro.png
// module id = 487
// module chunks = 1